<template>
  <v-container>
    <v-row>
      <v-col>
        <h1 class="mb-5">Login</h1>

        <v-form
          id="login-content--login-form"
          ref="loginForm"
          v-model="loginFormValid"
          @submit="validateLoginForm"
        >
          <v-alert
            id="login-content--login-form--error-alert"
            v-if="'' !== htmlFormErrorMessage"
            type="error"
            dense
            outlined
            class="mb-5"
          >
            <span v-html="htmlFormErrorMessage"></span>
          </v-alert>
          <v-alert
            id="login-content--login-form--success-alert"
            v-if="'' !== htmlFormSuccessMessage"
            type="success"
            dense
            outlined
            class="mb-5"
          >
            <span v-html="htmlFormSuccessMessage"></span>
          </v-alert>

          <v-text-field
            id="login-content--login-form--email-input"
            class="mb-2"
            v-model="emailInput"
            :disabled="!loginFormControlEnabled"
            :rules="emailValidationRules"
            type="email"
            label="Email"
            placeholder="Email"
            required
          ></v-text-field>

          <v-text-field
            id="login-content--login-form--password-input"
            class="mb-2"
            v-model="passwordInput"
            :disabled="!loginFormControlEnabled"
            :rules="passwordValidationRules"
            type="password"
            label="Password"
            placeholder="Password"
            required
          ></v-text-field>

          <v-btn
            id="login-content--login-form--login-button"
            :disabled="!loginFormValid || !loginFormControlEnabled"
            :loading="loginFormValidationActionInProgress"
            color="primary"
            class="mt-5 white--text"
            type="submit"
          >
            Login
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import storeAction from "../lib/const/storeAction";

export default {
  data() {
    return {
      htmlFormErrorMessage: "",
      htmlFormSuccessMessage: "",
      loginFormValid: false,

      emailInput: "",
      emailValidationRules: [],

      passwordInput: "",
      passwordValidationRules: [],

      loginFormValidationActionInProgress: false,
    };
  },

  computed: {
    loginFormControlEnabled() {
      return !this.loginFormValidationActionInProgress;
    },
  },

  methods: {
    async validateLoginForm(event) {
      event.preventDefault();
      this.htmlFormErrorMessage = "";
      this.htmlFormSuccessMessage = "";

      this.loginFormValidationActionInProgress = true;

      const loginData = {
        email: this.emailInput,
        password: this.passwordInput,
      };
      const idToken = await this.$store.dispatch(storeAction.POST_USER_AUTH_LOGIN, loginData)
      .catch((err) => {
        const priorityHtmlErrorMessageHash = {
          401: "<span>Invalid <b>Email</b> and/or <b>Password</b></span>",
        };
        this.htmlFormErrorMessage
          = this.$app.userCommon.getApiHtmlErrorMessage(err, priorityHtmlErrorMessageHash);
      });

      if (idToken) {
        this.htmlFormSuccessMessage = "<span>Login successful</span>";
        this.$app.authCommonAdapter.enforceUserAuthStrategy(this.$route);
        // Disable form control while waiting for page redirect
      } else {
        this.loginFormValidationActionInProgress = false;
      }
    },
  },

  mounted() {
    this.emailValidationRules = this.$app.validationCommon.emailValidationRules;
    this.passwordValidationRules = this.$app.validationCommon.passwordValidationRules;
  },
};
</script>
